/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ change: NonNullable<unknown>, count: NonNullable<unknown>, period: NonNullable<unknown> }} Progress_Report_Exercise_ChangeInputs */

const en_us2_progress_report_exercise_change = /** @type {(inputs: Progress_Report_Exercise_ChangeInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} in 1 week`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.change} in ${i?.count} weeks`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} in 1 month`);
	return /** @type {LocalizedString} */ (`${i?.change} in ${i?.count} months`)
	
};

const pt_br2_progress_report_exercise_change = /** @type {(inputs: Progress_Report_Exercise_ChangeInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} em 1 semana`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.change} em ${i?.count} semanas`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} em 1 mês`);
	return /** @type {LocalizedString} */ (`${i?.change} em ${i?.count} meses`)
	
};

const es_419_progress_report_exercise_change = /** @type {(inputs: Progress_Report_Exercise_ChangeInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} en 1 semana`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.change} en ${i?.count} semanas`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} en 1 mes`);
	return /** @type {LocalizedString} */ (`${i?.change} en ${i?.count} meses`)
	
};

const pt_pt2_progress_report_exercise_change = /** @type {(inputs: Progress_Report_Exercise_ChangeInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} em 1 semana`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.change} em ${i?.count} semanas`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} em 1 mês`);
	return /** @type {LocalizedString} */ (`${i?.change} em ${i?.count} meses`)
	
};

const fr_fr2_progress_report_exercise_change = /** @type {(inputs: Progress_Report_Exercise_ChangeInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} en 1 semaine`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.change} en ${i?.count} semaines`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} en 1 mois`);
	return /** @type {LocalizedString} */ (`${i?.change} en ${i?.count} mois`)
	
};

const de_de2_progress_report_exercise_change = /** @type {(inputs: Progress_Report_Exercise_ChangeInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} in 1 Woche`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.change} in ${i?.count} Wochen`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} in 1 Monat`);
	return /** @type {LocalizedString} */ (`${i?.change} in ${i?.count} Monaten`)
	
};

const it_it2_progress_report_exercise_change = /** @type {(inputs: Progress_Report_Exercise_ChangeInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} in 1 settimana`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.change} in ${i?.count} settimane`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`${i?.change} in 1 mese`);
	return /** @type {LocalizedString} */ (`${i?.change} in ${i?.count} mesi`)
	
};

/**
* | period | count | output |
* | --- | --- | --- |
* | "week" | "1" | "{change} in 1 week" |
* | "week" | * | "{change} in {count} weeks" |
* | * | "1" | "{change} in 1 month" |
* | * | * | "{change} in {count} months" |
*
* @param {Progress_Report_Exercise_ChangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_exercise_change = /** @type {((inputs: Progress_Report_Exercise_ChangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Exercise_ChangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_exercise_change(inputs)
	if (locale === "es-419") return es_419_progress_report_exercise_change(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_exercise_change(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_exercise_change(inputs)
	if (locale === "de-DE") return de_de2_progress_report_exercise_change(inputs)
	if (locale === "it-IT") return it_it2_progress_report_exercise_change(inputs)
	return en_us2_progress_report_exercise_change(inputs)
});
export { progress_report_exercise_change as "progress-report.exercise_change" }